import { useWorkflowStore } from '@/stores/workflow-store';
import { ApprovalButtons } from '@/components/chat/QuickReplies';

interface ApprovalGateSheetProps {
  conversationId: string;
}

/**
 * Mobile-only sticky bottom sheet for an active approval gate.
 * Reads the same workflow-store gate state the inline desktop card uses,
 * and reuses ApprovalButtons so the approve/reject behavior is identical.
 */
export function ApprovalGateSheet({
  conversationId,
}: ApprovalGateSheetProps): React.ReactElement | null {
  const gate = useWorkflowStore(s => s.activeApprovalGates.get(conversationId));

  if (!gate || gate.resolved) return null;

  return (
    <div className="border-t border-primary/40 bg-surface-elevated px-4 py-3 shadow-[0_-4px_16px_rgba(0,0,0,0.3)] md:hidden">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-primary">
        Approval required
      </p>
      {gate.message && <p className="mb-3 text-sm text-text-primary">{gate.message}</p>}
      <ApprovalButtons gate={gate} conversationId={conversationId} />
    </div>
  );
}
